export default [
  { role: 'ROLE_KT_EMPLOYEE', name: 'Сотрудник КТ' },
  { role: 'ROLE_KT_ADMIN', name: 'Администратор КТ' },
  { role: 'ROLE_SYSTEM_ADMIN', name: 'Администратор системы' },
  { role: 'ROLE_STOCK', name: 'Кладовщик' }
]
